export default __webpack_public_path__ + "static/media/logo.6096efb7.svg";